module.exports = __webpack_public_path__ + "static/16.5_Later_Middle_Ages-7b23fe7432a6071924f027bf30b48d0d.pdf";